import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
@Injectable()
export class AirbrakeErrorHandler implements ErrorHandler {

  constructor(
    private notifications: NotificationsService
  ) { }

  handleError(error: any): void {
    if (environment.env !== 'PROD') {
      // log errors in console if any
      console.error(error);
    }
  }

  notifyErrors(error: string): void {
    switch (error) {
      case "CLOSED_INVESTIGATIONS_FILTER_REQUIRED":
        this.notifications.snackbarError("Please provide at least one filter to search closed investigations.");
        break;

      case "CLOSED_INVESTIGATIONS_REACTED_LIMIT":
        this.notifications.snackbarError("You have reached the maximum number searches. Please try again later or contact admin.");
        break;
      default:
        break;

    }
  }

}
